import { STORE_NEW_TOKEN } from '../modules/authentication/types/authentication.types';
import { store } from '../store/store';

const apiResponseHandler = async (response: any) => {
  const state = store.getState();

  if (response.data.accessToken && state.authentication.token) {
    if (response.data.accessToken !== state.authentication.token) {
      store.dispatch({
        type: STORE_NEW_TOKEN,
        payload: {
          token: response.data.accessToken
        }
      });
    }
  }

  return response;
};

export default apiResponseHandler;
